import { all } from 'redux-saga/effects';

import commonSagas from 'us.common/sagas'
import GlobalSearchSaga from 'sagas'

let sagas = [
  ...commonSagas,
  ...GlobalSearchSaga
];

function* rootSaga() {
  yield all(sagas);
}

export default rootSaga;